export const TEST_ID = 'drawerTabBody';
